import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight, Compass } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { useSEO } from "../lib/seo";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/professor-mentale", label: "Professor Mentale course" },
  { to: "/pricing", label: "Pricing" },
  { to: "/mind-lab", label: "The Mind Lab" },
  { to: "/contact", label: "Contact" },
];

export default function NotFound() {
  const { pathname } = useLocation();
  useSEO({ title: "Page not found | Officium Mentale", description: "This page doesn't exist. Start at the homepage, the Professor Mentale course, or the Mind Lab.", path: pathname, robots: "noindex,follow" });
  return (
    <div data-testid="not-found-page">
      <PageHeader
        eyebrow="404 · Page not found"
        title="This path doesn't"
        italicTitle="lead anywhere."
        intro={`We couldn't find “${pathname}”. It may have moved, or the link may be out of date. Here are a few places worth going instead.`}
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-28">
        <div className="rounded-[2rem] bg-navy text-cream p-8 md:p-12 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <span className="w-14 h-14 rounded-2xl bg-cream/10 text-gold flex items-center justify-center"><Compass size={26} strokeWidth={1.6} /></span>
            <p className="mt-6 font-serif text-2xl md:text-3xl leading-snug">A wrong turn is just a question you haven't asked yet.</p>
            <p className="mt-4 text-cream/70">What were you looking for? If you followed a link from somewhere, let us know and we'll fix it.</p>
          </div>
          <ul className="lg:col-span-7 grid sm:grid-cols-2 gap-3" data-testid="not-found-links">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`not-found-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="group flex items-center justify-between rounded-xl border border-cream/15 px-5 py-4 hover:bg-cream hover:text-navy-deep transition-colors">
                  <span className="font-semibold">{l.label}</span>
                  <ArrowUpRight size={18} className="text-gold group-hover:rotate-45 transition-transform" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
